import { Checkbox, Divider, Form, FormInstance, Radio, Typography } from 'antd';
import { useIntl } from 'react-intl';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import { CheckboxGroupButtons } from '@/components/_common';
import BillsToPayMoreOptions from './BillsToPayMoreOptions';
import {
  FilterByDateByReportBillsToPay,
  ReportBillsToPayFormValues,
  ReportTypeReportBillsToPay,
  SituationReportBillsToPay,
} from '@/core/domain/reports/financial/billsToPay/BillsToPay.types';

interface Props {
  form: FormInstance<ReportBillsToPayFormValues>;
}
export default function BillsToPayForm({ form }: Props) {
  const intl = useIntl().formatMessage;
  const { Title } = Typography;
  const watchReportType = Form.useWatch('reportType', form);

  const situationOptions = [
    {
      value: SituationReportBillsToPay.open,
      label: intl({ id: 'financial.billsToPay.option.open' }),
    },
    {
      value: SituationReportBillsToPay.settled,
      label: intl({ id: 'financial.billsToPay.option.liquidated' }),
    },
  ];

  const filterByDateByOptions = [
    {
      value: FilterByDateByReportBillsToPay.emission,
      label: intl({ id: 'financial.billsToPay.option.emission' }),
    },
    {
      value: FilterByDateByReportBillsToPay.expiration,
      label: intl({ id: 'financial.billsToPay.option.expiration' }),
    },
    {
      value: FilterByDateByReportBillsToPay.payment,
      label: intl({ id: 'financial.billsToPay.option.payment' }),
    },
  ];

  const reportTypeOptions = [
    {
      value: ReportTypeReportBillsToPay.emission,
      label: intl({ id: 'financial.billsToPay.option.emission' }),
    },
    {
      value: ReportTypeReportBillsToPay.expiration,
      label: intl({ id: 'financial.billsToPay.option.expiration' }),
    },
    {
      value: ReportTypeReportBillsToPay.payment,
      label: intl({ id: 'financial.billsToPay.option.payment' }),
    },
    {
      value: ReportTypeReportBillsToPay.accountPlans,
      label: intl({ id: 'financial.billsToPay.option.accountPlans' }),
    },
    {
      value: ReportTypeReportBillsToPay.bankAccount,
      label: intl({ id: 'financial.billsToPay.option.bankAccount' }),
    },
  ];

  const isSynthetic =
    watchReportType === ReportTypeReportBillsToPay.accountPlans;

  const isLandingPage = [
    ReportTypeReportBillsToPay.payment,
    ReportTypeReportBillsToPay.expiration,
    ReportTypeReportBillsToPay.emission,
  ].includes(watchReportType);

  return (
    <Form form={form} layout="vertical">
      <ReportSelectMonthFields
        form={form}
        dateFilter={
          <Form.Item
            style={{ margin: '4px 0' }}
            name="dateType"
            label={
              <Title level={5} style={{ margin: '0' }}>
                {intl({ id: 'financial.billsToPay.label.filterByDate' })}
              </Title>
            }
            initialValue={FilterByDateByReportBillsToPay.emission}
          >
            <Radio.Group
              buttonStyle="solid"
              optionType="button"
              options={filterByDateByOptions}
              size="large"
            />
          </Form.Item>
        }
      />

      <Form.Item
        style={{ margin: '4px 0' }}
        name="lsSituacao"
        label={
          <Title level={5} style={{ margin: '0' }}>
            {intl({ id: 'financial.billsToPay.label.status' })}
          </Title>
        }
        initialValue={[SituationReportBillsToPay.open]}
      >
        <CheckboxGroupButtons options={situationOptions} />
      </Form.Item>

      <Form.Item
        style={{ margin: '4px 0' }}
        name="reportType"
        label={
          <Title level={5} style={{ margin: '0' }}>
            {intl({ id: 'financial.billsToPay.label.reportType' })}
          </Title>
        }
        initialValue={ReportTypeReportBillsToPay.emission}
      >
        <Radio.Group
          buttonStyle="solid"
          optionType="button"
          options={reportTypeOptions}
          size="large"
        />
      </Form.Item>

      {isSynthetic && (
        <Form.Item
          noStyle
          shouldUpdate
          name="synthetic"
          valuePropName="checked"
        >
          <Checkbox style={{ marginTop: 7, marginBottom: 20 }}>
            {intl({ id: 'financial.billsToPay.checkbox.synthetic' })}
          </Checkbox>
        </Form.Item>
      )}

      {isLandingPage && (
        <Form.Item
          noStyle
          shouldUpdate
          name="landingPage"
          valuePropName="checked"
        >
          <Checkbox style={{ marginTop: 7, marginBottom: 20 }}>
            Exibir em formato de página paisagem
          </Checkbox>
        </Form.Item>
      )}

      <Divider />
      <BillsToPayMoreOptions form={form} />
    </Form>
  );
}
